import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ServicosService } from './servicos.service';

export interface PerfilSistema {
  codigo: number;
  id: string;
  nome: string;
  descricao: string;
  tipo: string;
}

const STORAGE_KEY = 'perfis_sistema';

@Injectable({
  providedIn: 'root'
})
export class PerfilResolverService {

  constructor(
    private http: HttpClient,
    private servicos: ServicosService
  ) {}

  /**
   * Carrega perfis do localStorage (cache) ou da API corporativa.
   * Salva no localStorage para uso síncrono posterior.
   */
  carregarPerfis(): Observable<PerfilSistema[]> {
    const cached = localStorage.getItem(STORAGE_KEY);
    if (cached) {
      try {
        return of(JSON.parse(cached) as PerfilSistema[]);
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }

    const url = this.servicos.urls.urlPerfisSistema;
    return this.http.get<PerfilSistema[]>(url).pipe(
      tap(perfis => localStorage.setItem(STORAGE_KEY, JSON.stringify(perfis)))
    );
  }

  /**
   * Resolve codigoPerfil numérico para id string (ex: 2405 → "PIT.3").
   * Versão assíncrona — carrega do cache ou API.
   */
  resolverPerfilId(codigoPerfil: number): Observable<string> {
    return this.carregarPerfis().pipe(
      map(perfis => {
        const found = perfis.find(p => p.codigo === codigoPerfil);
        return found?.id ?? '';
      })
    );
  }

  /**
   * Resolve codigoPerfil numérico para id string de forma síncrona.
   * Lê diretamente do localStorage — requer que carregarPerfis() já tenha sido chamado.
   */
  resolverPerfilIdSync(codigoPerfil: number): string {
    const cached = localStorage.getItem(STORAGE_KEY);
    if (!cached) return '';
    try {
      const perfis: PerfilSistema[] = JSON.parse(cached);
      const found = perfis.find(p => p.codigo === codigoPerfil);
      return found?.id ?? '';
    } catch {
      return '';
    }
  }

  /**
   * Limpa o cache de perfis do localStorage (chamado no logout).
   */
  limparCache(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}
